/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, imageTypes } from '@insticator/insticator-ui'; // iui-utils
import { url } from 'utils/urls';



/* ++++++++++ --------------- EXPORT : EMBED PREVIEW : STYLES --------------- ++++++++++ */
export default theme => ({
	preview: {
		maxWidth: pxToEm(882),

		// visual site graphic
		'& .visual': {
			display: 'flex',
			alignItems: 'center',
			'& .device': {
				extend: imageTypes.graphic,
				position: 'relative',
				overflow: 'hidden',
				'& .embed-example': {
					position: 'absolute',
					height: '100%'
				},
				'&.desktop': {
					width: pxToEm(882),
					height: pxToEm(683)
				}
			}
		},

		// ..... RAIL ..... //
		'&.rail': {
			'& .visual': {
				'& .device': {
					'&.desktop': {
						backgroundImage: `url(${url.image}/mks/graphic-placement-rail-large.png)`,
						'& .embed-example': {
							top: pxToEm(38.4),
							right: pxToEm(25),
							width: pxToEm(300)
						}
					}
				}
			}
		},

		// ..... IN CONTENT ..... //
		'&.incontent': {
			'& .visual': {
				'& .device': {
					'&.desktop': {
						backgroundImage: `url(${url.image}/mks/graphic-placement-incontent-large.png)`,
						'& .embed-example': {
							top: pxToEm(240),
							right: pxToEm(145),
							width: pxToEm(600),
							'& #div-insticator-ad-1': {
								borderRight: replacePXinStringWithEM(`1px solid ${theme.color.light.light.swatch}`)
							}
						}
					}
				}
			}
		},
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	// remove browser background image and only show embed at smaller screen sizes
	[`@media only screen and (min-width:${pxToEm(0)}) and (max-width:${pxToEm(968)})`]: {
		preview: {
			minWidth: pxToEm(300),
			width: 'auto !important',
			'& .device': {
				background: 'none !important',
				width: 'auto !important',
				height: 'auto !important',
				'& .embed-example': {
					position: 'relative !important',
					top: '0 !important',
					right: '0 !important'
				}
			}
		}
	}
});
